import React from "react";

const Description = () => {
	return (
		<section className="page-main__description description">
			<p className="description__text">
				Company <span className="description__company-name">ElSmart</span> –
				holds a competition for children in which children of all ages{" "}
				<span className="description__deatails">can participate! </span>
				Nominations in which you can win, there is an opportunity to prove
				yourself in all directions and even{" "}
				<span className="description__deatails">
					without artistic abilities.
				</span>
			</p>
		</section>
	);
};

export default Description;
